import type { ReactNode } from "react";
import { NotificationCenter } from "@/components/NotificationCenter";
import { ThemeToggle } from "@/components/ThemeToggle";
import { UserAccountMenu } from "@/components/UserAccountMenu";
import { useTenantContext } from "@/lib/tenant-context";
import { cn } from "@/lib/utils";

export interface HeaderProps {
  title?: string;
  subtitle?: string;
  actions?: ReactNode;
  className?: string;
}

/**
 * Header del Design System — mismo contrato funcional que DashboardHeader.
 */
export function Header({ title, subtitle, actions, className }: HeaderProps) {
  const { tenantId, tenantName } = useTenantContext();

  return (
    <header
      className={cn(
        "sticky top-0 z-30 flex min-h-[4.5rem] items-center justify-between gap-4 border-b border-border bg-card/90 px-gutter py-3 backdrop-blur-md",
        className,
      )}
    >
      <div className="flex min-w-0 flex-1 flex-wrap items-center gap-4">
        <div>
          {title ? <h2 className="text-headline-md font-bold tracking-tight text-foreground">{title}</h2> : null}
          {subtitle ? <p className="text-xs text-muted-foreground">{subtitle}</p> : null}
        </div>
        {actions}
      </div>

      <div className="flex items-center gap-3 sm:gap-4">
        <ThemeToggle />
        <NotificationCenter tenantId={tenantId} tenantName={tenantName} />
        <UserAccountMenu
          triggerClassName="focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary"
        />
      </div>
    </header>
  );
}
